import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import TemplateDelete from './TemplateDelete';
import TemplateEditing from './TemplateEditing';

const StyledContainer = styled.div`
  font-size: 15px;
`;

const StyledTemplateNameContainer = styled.div`
  display: flex;
  align-items: center;
`;

// получение классов стиля для компонента в зависимости от текущего состояния компонента
const getClassname = (isCreatingTemplate, hover, idUsingTemplate, template) => {
  const className = ' item-template';
  if (template && idUsingTemplate === template.id) {
    return `${className} item-template-active`;
  }
  if (hover) {
    return `${className} item-template-hover`;
  }
  return className;
};

const TemplateItem = (props) => {
  const { template, onDelete, onToggle, idUsingTemplate } = props;

  const isCreatingTemplate = !!template;
  const [templateName, setTemplateName] = useState(template ? template.name : '');
  const [showEdit, setShowEdit] = useState(!isCreatingTemplate);

  useEffect(() => {
    setTemplateName(template ? template.name : '');
  }, [template]);
  const [hover, setHover] = useState(false);
  const handleMouseHover = () => {
    setHover(!hover);
  };

  useEffect(() => {
    if (template !== undefined && template.id !== idUsingTemplate) {
      setTemplateName(template.name);
      setShowEdit(false);
    }
    if (idUsingTemplate === undefined && template !== undefined) {
      setShowEdit(false);
    }
    setHover(false);
  }, [idUsingTemplate, template]);

  return (
    <div
      onMouseEnter={handleMouseHover}
      onMouseLeave={handleMouseHover}
      className={getClassname(isCreatingTemplate, hover, idUsingTemplate, template)}
      onClick={() => {
        if (template) {
          onToggle(template);
        }
      }}
      onKeyDown={() => {}}
    >
      <StyledContainer className="flex-style-space-between">
        <div className="flex-style-space-between">
          <TemplateEditing
            {...props}
            templateName={templateName}
            setTemplateName={setTemplateName}
            showEdit={showEdit}
            setShowEdit={setShowEdit}
            isCreatingTemplate={isCreatingTemplate}
          />
          {!showEdit ? (
            <StyledTemplateNameContainer>{templateName}</StyledTemplateNameContainer>
          ) : undefined}
        </div>
        {template ? (
          <TemplateDelete
            isCloseClick={template !== undefined && template.id === idUsingTemplate}
            onDelete={() => onDelete(template.id)}
            templateName={template.name}
          />
        ) : undefined}
      </StyledContainer>
    </div>
  );
};

export default TemplateItem;
